angular
    .module('tradersyard')
    .run([
        'graph-api-client',
        'graph-group-factory',
        function ($api, $factory) {
            $api.factory.group = $factory;
        },
    ])
    .factory('graph-group-factory', [
        '$q',
        'graph-api-client',
        'graph-api-client-v2',
        'graph-participant-factory',
        'graph-request-factory',
        'graph-like-factory',
        'graph-document-factory',
        'graph-photo-factory',
        'graph-video-factory',
        'graph-post-factory',
        'graph-news-factory',
        'graph-search-factory',
        'graph-blacklist-factory',
        function (
            $q,
            client,
            clientv2,
            participants,
            requests,
            likes,
            documents,
            photos,
            videos,
            posts,
            news,
            search,
            blacklists
        ) {
            var GROUP = 'group';

            /**
             *  @type {String}
             */
            return {
                uploadGroupPhoto: uploadGroupPhoto,
                attachHeaderImage: attachHeaderImage,
                createGroup,

                joined: function () {
                    return clientv2.get('groups/joined');
                },

                own: function () {
                    return clientv2.get('groups/own');
                },

                top: function () {
                    return clientv2.get('groups/top');
                },

                query: function (id, options) {
                    return client.get([id, 'groups'], options);
                },
                read: function (id, options) {
                    return client.get(['group', id], options);
                },
                create: function (data, options) {
                    return client.post(['groups'], data, options);
                },
                update: function (id, data, options) {
                    return client.post(['group', id], data, options);
                },
                start: function (id, options) {
                    return client.post(['group', id, 'start'], undefined, options);
                },
                end: function (id, options) {
                    return client.post(['group', id, 'end'], undefined, options);
                },
                cancel: function (id, options) {
                    return client.post(['group', id, 'cancel'], undefined, options);
                },
                delete: function (id, options) {
                    return client.delete(['group', id], options);
                },
                categories: function (options) {
                    return client.get(['group', 'categories'], options);
                },
                blacklists: function (id) {
                    return blacklists.entry(GROUP, id);
                },
                requests: function (id) {
                    return requests.entry('group', id);
                },
                participants: function (id) {
                    return participants.entry(GROUP, id, 'participants');
                },
                likes: function (id) {
                    return likes.entry(GROUP, id);
                },
                documents: function (id) {
                    return documents.entry(GROUP, id);
                },
                posts: function (id) {
                    return posts.entry(GROUP, id);
                },
                queryRelatedProducts: function (groupId) {
                    return client.get(['group', groupId, 'related-products'], { params: { limit: 100 } });
                },
                addRelatedProduct: function (groupId, productUrl) {
                    return client.post(['group', groupId, 'related-products'], { url: productUrl });
                },
                removeRelatedProduct: function (groupId, linkId) {
                    return client.delete(['group', groupId, 'related-product', linkId]);
                },
                news: function (id) {
                    return news.entry(GROUP, id);
                },
                picture: function (id) {
                    return photos.entry(GROUP, id, 'picture');
                },
                photos: function (id) {
                    return photos.entry(GROUP, id, 'photos');
                },
                videos: function (id) {
                    return videos.entry(GROUP, id, 'videos');
                },
                meeting: function (id, options) {
                    return client.get(['group', id, 'meeting'], options);
                },
                search: function (query, options) {
                    return search.entry(GROUP).search(query, options);
                },
            };

            async function createGroup(data, options) {
                return _promisify(client.post(['groups'], data, options));
            }

            /**
             * Set given photo as header image of Group
             *
             * @param {string|number} groupId
             * @param {string|number} photoId
             * @returns {angular.IPromise<object>}
             */
            function attachHeaderImage(groupId, photoId) {
                var photosEntryTerm = 'picture';
                var photosEntry = photos.entry(GROUP, groupId, photosEntryTerm);

                return photosEntry.attach(photoId, {}).then(function (response) {
                    return response.data.state === 0 ? response.data.data : $q.reject();
                });
            }

            /**
             * Upload a photo and associate it with a given Group ID.
             *
             * Resolves on success with photo entity data.
             * Rejects with upload error message.
             *
             * @param {string|number} groupId
             * @param {{name: string, data64: string}} photoData
             * @returns {ng.IPromise}
             */
            function uploadGroupPhoto(groupId, photoData) {
                // Not important in case of `upload` method. In other cases it changes the called API endpoint.
                var photosEntryTerm = 'photos';
                var photosEntry = photos.entry(GROUP, groupId, photosEntryTerm);
                var uploadData = { name: photoData.name, photo: photoData.data64 };

                return photosEntry.upload(uploadData, {}).then(function (response) {
                    if (response.data.state !== 0) {
                        return $q.reject('The file is too large or the format is incorrect.');
                    }

                    return response.data.data;
                });
            }

            /**
             * Transform the shitty response envelope to behave properly with a promise.
             * - resolve data on valid state
             * - reject on invalid state
             * @param request
             * @return {Promise<*>}
             * @private
             */
            async function _promisify(request) {
                const response = await request;
                return response.data.state === 0 ? response.data.data : Promise.reject(response.data.data);
            }
        },
    ]);
